var currentUrl = window.location.href;
jQuery(document).ready(function ($) {

    $('select').selectric({
        openOnFocus: false,
        disableOnMobile: false,
        nativeOnMobile: false
    });
    jQuery(".our_airports_boxes .boxes_list_section .hover_link").click(function () {
        setTimeout(function () {
            $('.lity').addClass('our_airport_boxes_popup_open');
            $('body').addClass('our_airport_boxes_popup_active');
        });
    });

    $slick_prev = '<button type="button" class="slick-prev"><svg width="67" height="68" viewBox="0 0 67 68" fill="none" xmlns="http://www.w3.org/2000/svg"><title>Prevoius</title><rect width="66.4194" height="66.4194" rx="33.2097" transform="matrix(-1 0 0 1 66.8555 0.983398)" fill="#00B4A9"/><path d="M32.2742 26.0656C31.3998 26.94 26.4451 31.8948 24.077 34.262\M24.077 34.2629L31.4545 41.6404M24.077 34.2629H42.6574" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
    $slick_next = '<button type="button" class="slick-next"><svg width="67" height="68" viewBox="0 0 67 68" fill="none" xmlns="http://www.w3.org/2000/svg"><title>Next</title><rect x="0.5" y="0.983398" width="66.4194" height="66.4194" rx="33.2097" fill="#00B4A9"/><path d="M35.0812 26.0656C35.9556 26.94 40.9104 31.8948 43.2785 34.2629M43.2785 34.2629L35.901 41.6404M43.2785 34.2629H24.6981" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';

    $(".site-navigation-toggle-open").click(function () {
        if ($('.site-header').hasClass("menu_active")) {
            $('.site-header').removeClass("menu_active");
            $('body').removeClass("toggle_menu_active");
            $(this).attr("aria-expanded", "false");
            $(this).attr("aria-label", "Open navigation menu");
        } else {
            $('.site-header').addClass("menu_active");
            $('body').addClass("toggle_menu_active");
            $(this).attr("aria-expanded", "true");
            $(this).attr("aria-label", "Close navigation menu");
        }
    });

    $(".site-navigation-toggle-close").click(function () {
        $('.site-header').removeClass("menu_active");
        $('body').removeClass("toggle_menu_active");
        if ($('nav.primary-navigation li.menu-item-has-children').hasClass("open")) {
            $('nav.primary-navigation li.menu-item-has-children button.submenu-toggle').removeClass("active");
            $('nav.primary-navigation li.menu-item-has-children').removeClass("open");
            $('nav.primary-navigation li.menu-item-has-children .sub-menu').slideUp();
        }
    });

    $('nav.primary-navigation').find('li.menu-item-has-children > a').after('<button class="submenu-toggle"><svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg"><title>Dropdown Arrow</title><path d="M1 1.5L5 5.5L9 1.5" stroke="black" stroke-width="2"/></svg></button>');
    $('body').on('click', 'nav.primary-navigation button.submenu-toggle', function () {
        $(this).parent().siblings().find('button.submenu-toggle').removeClass("active");
        $(this).parent().siblings().find('button.submenu-toggle').parent().find('> .sub-menu').slideUp().parent().removeClass('open');
        $(this).toggleClass('active').parent().find('> .sub-menu').slideToggle().parent().toggleClass('open');
    });

    $(".site-header-cta > .btn.with_popup").click(function () {
        $('.site-header').removeClass("menu_active");
        $('body').removeClass("toggle_menu_active");
    });

    $('.image_content_slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        prevArrow: $slick_prev,
        nextArrow: $slick_next,
        appendArrows: $(".full_width_image_with_content_main .full_width_image_with_content_inner_data_arrows"),
        appendDots: $(".full_width_image_with_content_main .full_width_image_with_content_inner_data_dots"),
        autoplay: false,
        autoplaySpeed: 3000,
        focusOnSelect: true,
        variableWidth: false,
        adaptiveHeight: true,
        infinite: true,
        fade: true,
        speed: 1000,
    });

    $('.our_partners_inner_wrapper').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 2000,
        focusOnSelect: true,
        variableWidth: true,
        infinite: true,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                variableWidth: false,
            }
        }]
    });

    $('.team_slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        autoplay: false,
        autoplaySpeed: 2000,
        focusOnSelect: true,
        variableWidth: false,
        infinite: true,
        prevArrow: $slick_prev,
        nextArrow: $slick_next,
        appendArrows: '.team_inner_data_arrows',
        responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    autoplay: true,
                    variableWidth: true,
                    dots: true,
                }
            }
        ]
    });

    jQuery(".charts_inner_list_item .hover").click(function () {
        $('body').addClass('charts_popup_active');
    });

    jQuery(".heading_content_with_boxes_inner_wrapper .item .link").click(function () {
        $('body').addClass('box_popup_active');
    });

    $(".reviews_popup_sec .popup_link a").click(function () {
        $('body').addClass("reviews_popup_active");
    });


    $(".left_right_content_with_video_popup .btn_item a").click(function () {
        $('body').addClass("left_right_popup_active");
    });

    $(".heading_content_with_boxes_inner_wrapper .item a").click(function () {
        // $('body').addClass("heading_content_with_boxes_active");
    });

    jQuery(document).on('lity:close', function (event, instance) {
        $('body').removeClass('reviews_popup_active');
        $('body').removeClass('left_right_popup_active');
        $('body').removeClass('box_popup_active');
    });

    $(".reviews").each(function (index) {
        var slider = $(this).find('.reviews_slider');
        var slide = $(this).find('.reviews_inner_list_item');
        var arrows = $(this).find('.reviews_inner_data_arrows');
        if (slide.length <= 4) {
            var arrow = false;
        } else {
            var arrow = true;
        }
        slider.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: arrow,
            dots: false,
            autoplay: false,
            autoplaySpeed: 2000,
            focusOnSelect: true,
            variableWidth: false,
            infinite: true,
            prevArrow: $slick_prev,
            nextArrow: $slick_next,
            appendArrows: arrows,
            responsive: [{
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        autoplay: true,
                        variableWidth: true,
                        dots: true,
                    }
                }
            ]
        });

    });


    $(".four_boxes_section").each(function (index) {
        var slider = $(this).find('.four_boxes_section_slider');
        var slide = $(this).find('.four_boxes_section_inner_list_item');
        var arrows = $(this).find('.four_boxes_section_inner_data_arrows');
        var dots = $(this).find('.section_dots');
        slider.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            appendDots: dots,
            autoplay: false,
            autoplaySpeed: 2000,
            focusOnSelect: true,
            variableWidth: false,
            infinite: true,
            prevArrow: $slick_prev,
            nextArrow: $slick_next,
            appendArrows: arrows,
            responsive: [{
                    breakpoint: 1440,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        autoplay: true,
                        dots: false,
                        arrows: false,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        autoplay: true,
                        dots: true,
                        arrows: false,
                        variableWidth: true,
                    }
                }
            ]
        });

    });


    customSelect();

    $(".accordion_heading").on("click", function (e) {
        e.preventDefault();
        if ($(this).next().is(":hidden")) {
            $(this).parent().parent().find(".accordion_content").slideUp();
            $(this).parent().parent().find(".accordion_heading").removeClass("active");
            $(this).addClass("active");
            $(this).next().slideDown();
        } else {
            $(this).removeClass("active");
            $(this).next().slideUp();
        }
    });

    equalheight('.news_list_sec__inner .list_item .news_list__item__inner .title');

    $('.product_banner_slider_for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.product_banner_slider_nav'
    });
    $('.product_banner_slider_nav').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.product_banner_slider_for',
        dots: false,
        focusOnSelect: true,
        variableWidth: false,
        infinite: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3500,
        responsive: [{
                breakpoint: 640,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 375,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            }
        ]
    });

    jQuery(".tab_with_left_right_content_and_product_info_sec .tab_list .tab_link").on("click", function () {
        var linkVal = jQuery(this).attr("href");
        if (linkVal.indexOf("_scroll") > -1) {
            linkVal = linkVal.replace("_scroll", "");
            if (jQuery(linkVal).length > 0) {
                jQuery("body, html").animate({
                    scrollTop: jQuery(linkVal).offset().top - 100
                }, 1000);
            }
        }
    })

    jQuery(document).on("change", ".enquiry_dropdown_field select", function() {
        var thisVal = jQuery(this).val();
        if (thisVal != "" && thisVal != undefined && thisVal != null) {
            var thisValArr = thisVal.split('|');
            if (thisValArr.length > 1) {
                jQuery(".enquiry_email_field input").val(thisValArr[1]);
            } else {
                jQuery(".enquiry_email_field input").val("info@b-cell-design.com");
            }
        } else {
            jQuery(".enquiry_email_field input").val("info@b-cell-design.com");
        }
    })

    var locHash = window.location.hash;
    if(locHash != undefined && locHash != "" && locHash != null) {
        if(jQuery(locHash + "_secscroll").length > 0) {
            jQuery("body, html").animate({
                scrollTop: jQuery(locHash + "_secscroll").offset().top-50
            }, 1000);
        }
    }
    jQuery("a[href*=#]:not([data-lity])").on("click", function(e) {
        e.preventDefault();
        var link1 = jQuery(this).attr("href");
        var target1 = jQuery(this).attr("target");
        if(target1 == undefined || target1 == null || target1 == "") {
            target1 = "_self";        
        }
        if(link1.indexOf("#") > -1) {
            var link1Arr = link1.split('#');
            if(link1Arr.length > 1) {
                var linkId = link1Arr[1];
                if(jQuery("#" + linkId + "_secscroll").length > 0) {
                    jQuery("body, html").animate({
                        scrollTop: jQuery("#" + linkId + "_secscroll").offset().top-50
                    }, 1000);
                } else {
                    window.open(link1, target1);
                }
            } else {
                window.open(link1, target1);
            }
        } else {
            window.open(link1, target1);
        }
    })

    if (currentUrl.indexOf("area=") > -1 && jQuery(".Products_main").length > 0) {
        jQuery("body, html").animate({
            scrollTop: jQuery(".Products_main").offset().top - 80
        }, 1000);
    }
});

jQuery(document).on('gform_page_loaded', function (event, form_id, current_page) {
    customSelect();
});

jQuery(window).resize(function () {
    equalheight('.news_list_sec__inner .list_item .news_list__item__inner .title');
});

function equalheight(container) {

    var currentTallest = 0,
        currentRowStart = 0,
        rowDivs = new Array(),
        $el,
        topPosition = 0;
    jQuery(container).each(function () {

        $el = jQuery(this);
        jQuery($el).height('auto')
        topPostion = $el.position().top;

        if (currentRowStart != topPostion) {
            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                rowDivs[currentDiv].height(currentTallest);
            }
            rowDivs.length = 0; // empty the array
            currentRowStart = topPostion;
            currentTallest = $el.height();
            rowDivs.push($el);
        } else {
            rowDivs.push($el);
            currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
        }
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
            rowDivs[currentDiv].height(currentTallest);
        }
    });
}

function customSelect() {
    jQuery('select').selectric({
        openOnFocus: false,
        disableOnMobile: false,
        nativeOnMobile: false
    });
    jQuery(document).ready(function () {
        jQuery(document).on("change", ".gfield select", function () {
            var val1 = jQuery(this).val();
            if (val1 != "") {
                jQuery(this).parent().parent().find(".selectric").addClass("selected");
            } else {
                jQuery(this).parent().parent().find(".selectric").removeClass("selected");
            }
        });
        jQuery(".gfield select").each(function () {
            var val1 = jQuery(this).val();
            if (val1 != "") {
                jQuery(this).parent().parent().find(".selectric").addClass("selected");
            } else {
                jQuery(this).parent().parent().find(".selectric").removeClass("selected");
            }
        })
    });
}